<template>
  <div>
    <div class="floated-chat-btn" @click="abrirModal">
      <i class="fas fa-check"></i>&nbsp;&nbsp;Agregar Detalle
    </div>
    <div
      class="onboarding-modal modal"
      id="entarimarModal"
      role="dialog"
      tabindex="-1"
      style="display: padding-right: 15px"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Salir</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div>
            <div class="onboarding-content">
              <h4 class="onboarding-title text-center">
                Agregar Producto o Servicio
              </h4>
              <div v-if="!tipo_servicio">
                <br />
                <br />
                <br />
                <br />
              </div>
              <div
                v-if="tipo_servicio && servicio_true == false"
                class="col-12"
              >
                <ProductoSelectComponentV2
                  @onChangeProducto="refreshDataPrecio(current)"
                  :current="current"
                />
              </div>
              <div
                v-if="tipo_servicio && servicio_true == true"
                class="col-sm-12"
              >
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.producto,
                    }"
                    >Producto</label
                  >
                  <v-select
                    label="sku"
                    v-model="current.producto"
                    :filterable="false"
                    @input="refreshDataPrecio(current)"
                    :options="productos"
                    @search="onSearch"
                  >
                    <template slot="no-options">Producto...</template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        <img :src="option.image" />
                        {{ option.sku }} - {{ option.nombre }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        <img :src="option.image" />
                        {{ option.sku }} - {{ option.nombre }}
                      </div>
                    </template>
                  </v-select>
                  <small
                    v-if="current.errors && current.errors.producto"
                    class="form-text text-danger"
                    >{{ current.errors.producto }}</small
                  >
                </div>
              </div>
              <div class="row">
                <div
                  style="overflow-y: scroll; max-height: 300px"
                  class="col-4"
                >
                  <!-------------------- Tabla de REsultados -------------------->
                  <table
                    class="table table-voice table-fixed table-condensed table-hover"
                  >
                    <thead>
                      <tr>
                        <th class="text-center">Tipos de Servicios</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="current in servicio" v-bind:key="current.id">
                        <td
                          @click="selectTipoServicio(current)"
                          v-if="current.id != tipo_servicio"
                          class="text-center"
                        >
                          {{ current.nombre }}
                        </td>
                        <td
                          @click="deSelectTipoServicio"
                          v-if="current.id == tipo_servicio"
                          class="bg-success form-control text-center"
                        >
                          <span class="badge font-italic text-light">{{
                            current.nombre
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="col-8">
                  <div class="row">
                    <div v-if="tipo_servicio" class="col-sm-12">
                      <div class="form-group">
                        <label>Cantidad</label>
                        <input
                          class="form-control"
                          placeholder="Cantidad"
                          type="number"
                          autocomplete="off"
                          step="0.01"
                          v-model="current.cantidad"
                        />
                        <small class="form-text text-danger" v-if="errors">{{
                          errors.cantidad
                        }}</small>
                      </div>
                    </div>
                    <div v-if="tipo_servicio" class="col-sm-12">
                      <div class="form-group">
                        <label for>Descripción</label>
                        <input
                          class="form-control"
                          placeholder="Descripcion"
                          type="text"
                          autocomplete="off"
                          v-model="current.descripcion"
                        />
                        <small class="form-text text-danger" v-if="errors">{{
                          errors.cantidad
                        }}</small>
                      </div>
                    </div>
                    <div v-if="tipo_servicio" class="col-sm-12">
                      <div class="form-group">
                        <label for>Precio</label>
                        <input
                          :disabled="precio_segun_producto == true"
                          class="form-control"
                          placeholder="Precio"
                          type="number"
                          step="0.01"
                          v-model="current.precio"
                        />
                      </div>
                    </div>
                    <div v-if="tipo_servicio" class="col-sm-12">
                      <UsuariosDeServiciosSelectComponent
                        titulo="Responsable de servicio"
                        :current="current"
                      />
                    </div>
                  </div>
                  <button
                    v-if="tipo_servicio"
                    class="btn btn-block btn-md btn-success"
                    type="button"
                    @click="agregarDetalle(current)"
                  >
                    Agregar Servicio
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import UsuariosDeServiciosSelectComponent from "@/components/commons/UsuariosDeServiciosSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    UsuariosDeServiciosSelectComponent,
  },
  props: {
    datos: {
      type: Object,
    },
  },
  computed: {},
  data() {
    return {
      servicio_true: false,
      precio_segun_producto: "",
      current: {
        descripcion: "",
        precio: "",
        cantidad: 1,
        producto: "",
        errors: [],
      },
      cantidad: null,
      errors: [],
      servicio: "",
      tipo_servicio: "",
      productos: [],
      det: {
        es_servicio: "",
      },
    };
  },
  mounted() {},
  methods: {
    refreshDataPrecio(current) {
      let self = this;
      current.descripcion = current.producto.nombre;
      DynamicService.getById("cat", "productos", current.producto.sku).then(
        (response) => {
          current.precio = response.data.lista_precios[0].precio;
        }
      );
    },
    deSelectTipoServicio() {
      let self = this;
      self.refreshDetalleDefault();
      self.tipo_servicio = "";
    },
    selectTipoServicio(det) {
      let self = this;
      self.precio_segun_producto = det.precio_segun_producto;
      self.refreshDetalleDefault();
      self.tipo_servicio = det.id;
      self.current.tipo_servicio = det.id;
      self.servicio_true = det.es_servicio;
      DynamicService.fetch("cat", "productos", {
        page: 1,
        es_servicio: det.es_servicio,
      }).then((res) => {
        self.productos = res.data.results;
      });
    },
    abrirModal() {
      let self = this;
      DynamicService.fetch("taller", "tipo-servicio", {
        quitar_paginacion: true,
      }).then((res) => {
        self.servicio = res.data;
      });
      DynamicService.fetch("cat", "productos", {
        page: 1,
        es_servicio: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      $("#entarimarModal").modal();
    },
    refreshDetalleDefault() {
      let self = this;
      self.tipo_servicio = "";
      self.current.producto = "";
      self.current.cantidad = 1;
      self.current.precio = "";
      self.current.descripcion = "";
      self.current.tipo_servicio = "";
    },
    agregarDetalle(current) {
      let self = this;
      if (current.usuario) {
        current.usuario_realiza = current.usuario.id;
      }
      console.log(current.usuario_realiza);
      current.producto = current.producto.sku;
      DynamicService.postAction(
        "taller",
        "orden-servicio",
        self.datos.id,
        "agregar_linea",
        current
      )
        .then((res) => {
          $("#entarimarModal").modal("hide");
          self.refreshDetalleDefault();
          self.$emit("refreshDetalle");
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar Detalle",
            error.response.data.detail
          );
        });
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      console.log(self.servicio);
      DynamicService.fetch("cat", "productos", {
        page: 1,
        quitar_paginacion: true,
        es_servicio: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
      loading(false);
    }, 350),
  },
};
</script>
